/* design system */
// export const BACKGROUND = "#fafafa";
export const BACKGROUND = '#ffffff';
export const ERROR_RED = '#ee5050';

export const BLACK_1 = '#000000'; // L 0%
export const BLACK_2 = '#14131c'; // L 9%
export const BLACK_3 = '#333333'; // L 20%
export const BLACK_4 = '#555555'; // L 33%
export const BLACK_5 = '#777777'; // L 47%

export const WHITE_1 = '#ffffff'; // L 100%
// export const PAPER_1 = '#fcfcfc';
// export const PAPER_1 = '#fbfbfb';
export const PAPER_1 = '#f7f7f7';

export const GRAY_1 = '#999999'; // L 60%
export const GRAY_2 = '#cbcbcd'; // L 80%
export const GRAY_3 = '#f1f1f1'; // L 95%
export const GRAY_4 = '#f5f5f5'; // L 96%
export const GRAY_5 = '#fafafa'; // L 98%

export const YELLOW_1 = '#f5c238'; // L 59%
export const YELLOW_2 = '#f6c90e'; // L 51%
export const YELLOW_3 = '#ffe066'; // L 70%
export const YELLOW_4 = '#fff0a5'; // L 82%
export const YELLOW_5 = '#fffae0'; // L 94%

export const BROWN_1 = '#7B3F00'; // L 24%
export const BROWN_2 = '#A26939'; // L 43%
export const BROWN_3 = '#f5e6d3'; // L 89%
export const BROWN_4 = '#fef6e9'; // L 96%
export const BROWN_5 = '#fffcf5'; // L 98%
// 학습지 배경색 후보: #f3f0e8 (디자인 시스템 미편입)

export const BLUE_1 = '#2a4f6e'; // L 30%
export const BLUE_2 = '#407195'; // L 42%
export const BLUE_3 = '#6a9bc2'; // L 59%
export const BLUE_4 = '#edf2f7'; // L 96%
export const BLUE_5 = '#f7fafd'; // L 98%

export const CYAN_1 = '#124554'; // L 20%
export const CYAN_2 = '#17596d'; // L 26%
export const CYAN_3 = '#207c97'; // L 36%
export const CYAN_4 = '#e6f5fa'; // L 94%
export const CYAN_5 = '#f2fafc'; // L 97%

export const RED_1 = '#b91c1c'; // L 41%
export const RED_2 = '#dc2626'; // L 51%
export const RED_3 = '#ee5050'; // L 62%
export const RED_4 = '#f8e9e9'; // L 96%
export const RED_5 = '#fdf8f8'; // L 98%

export const GREEN_1 = '#1e4620'; // L 20%
export const GREEN_2 = '#2d5a2f'; // L 26%
export const GREEN_3 = '#3b7e43'; // L 36%
export const GREEN_4 = '#5fa968'; // L 52%
export const GREEN_5 = '#f7fcf7'; // L 97%

// ############### box shadow ###############
// box-shadow: [x-offset] [y-offset] [blur-radius 흐림] [spread-radius? 퍼짐] [color];

// ############### modal color ###############
export const MODAL_COLOR = 'rgba(0, 0, 0, 0.3)';

// ############### common ###############
export const HIGHLIGHT_TEXT_COLOR = BROWN_2;
export const GRAY_BACKGROUND_COLOR = GRAY_5;
export const GRAY_BOX_BORDER_COLOR = GRAY_4;
// export const GRAY_BOX_BORDER_COLOR = GRAY_3;
export const GRAY_DISABLE_BUTTON_COLOR = GRAY_2;
export const GRAY_EDIT_COLOR = GRAY_1;
export const HOVER_SHADOW = '0px 1px 10px 0px rgba(0, 0, 0, 0.05)';
export const SURFACE_SHADOW = '0px 0px 10px 0px rgba(0, 0, 0, 0.10)';
export const SHEET_SHADOW = '0px 0px 10px 0px rgba(0, 0, 0, 0.15)';
export const HEADER_SHADOW = '0px 1px 5px 0px rgba(0, 0, 0, 0.05)';
export const BOTTOM_TAB_SHADOW = '0px -1px 5px 0px rgba(0, 0, 0, 0.05)';
export const FLOATING_SHADOW = '0px 2px 5px 0px rgba(0, 0, 0, 0.15)';
